import { NexusServicePromiseClient } from '@nxcr-org/web-api-interface/lib/nexus_service_grpc_web_pb'
import { oktaAuth, OktaAuthInterceptor } from '../../okta/config'
import { Env } from '../fleet-management/api/env'
import { ListDealershipsRequest, ViewTeamRequest } from '@nxcr-org/web-api-interface/lib/dealership_service_pb'
import { spyOnResponse } from '../../utils/spyOnResponse'

function getNexusService(): NexusServicePromiseClient {
  const idToken = oktaAuth.getIdToken()
  const target = Env.endpoints.fleet

  return new NexusServicePromiseClient(target, null, {
    unaryInterceptors: [new OktaAuthInterceptor(idToken)],
    'grpc-node.max_session_memory': 1000,
    'grpc-node.max_send_message_length': 1024 * 1024 * 100,
    'grpc-node.max_receive_message_length': 1024 * 1024 * 100,
  })
}

export async function listDealerships(){
  const client = getNexusService()
  const request = new ListDealershipsRequest()

  return client
    .listDealerships(request)
    .then(spyOnResponse('listDealerships'))
    .then((res) => {
      return res.toObject()
    })
}

export async function viewTeam(dealershipId: string){
  const client = getNexusService()
  const request = new ViewTeamRequest()
  request.setDealershipId(dealershipId)

  return client
    .viewTeam(request)
    .then(spyOnResponse('viewTeam'))
    .then((res) => {
      return res.toObject()
    })
}


